import { useMemo, useState } from "react";
import { animeList, matchReasons } from "@/mocks/anime";

export default function FateMatch() {
  const [current, setCurrent] = useState(0);

  const pick = useMemo(() => {
    const anime = animeList[current];
    const reasons = [
      matchReasons[current % matchReasons.length],
      matchReasons[(current + 3) % matchReasons.length],
      matchReasons[(current + 5) % matchReasons.length],
    ];
    const match = 90 + ((current * 7) % 9);
    return { anime, reasons, match };
  }, [current]);

  const reMatch = () => {
    let next = Math.floor(Math.random() * animeList.length);
    if (next === current) next = (next + 1) % animeList.length;
    setCurrent(next);
  };

  return (
    <section id="fate" className="relative py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <p className="inline-flex items-center gap-2 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-semibold px-4 py-1.5 mb-4">
            <i className="ri-heart-3-line"></i>
            今日缘分
          </p>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950">
            今日缘分匹配
          </h2>
          <p className="mt-3 md:mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            结合你的看番口味与当前心情，一键生成专属看番清单。今天，命运为你选好了这一部。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-10 items-center">
          {/* 缘分卡 左侧图片 */}
          <div className="relative mx-auto w-full max-w-md">
            <div className="absolute -inset-3 rounded-[2rem] bg-gradient-to-br from-primary-200/70 to-accent-200/70 -rotate-2"></div>
            <div className="relative rounded-[1.6rem] overflow-hidden bg-background-100 shadow-sm">
              <img
                src={pick.anime.image}
                alt={`小缘今日缘分匹配推荐番剧：${pick.anime.title}`}
                className="w-full h-[380px] md:h-[460px] object-cover object-top"
              />
              <div className="absolute top-4 left-4 inline-flex items-center gap-1 rounded-full bg-background-50/90 backdrop-blur-sm px-3 py-1.5 text-xs font-bold text-primary-600">
                <i className="ri-heart-3-fill text-primary-500"></i>
                缘分匹配 {pick.match}%
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent px-5 pt-14 pb-5">
                <p className="font-heading text-2xl md:text-3xl text-white">{pick.anime.title}</p>
                <div className="mt-2 flex flex-wrap gap-2">
                  {pick.anime.tags.map((t) => (
                    <span key={t} className="rounded-full bg-background-50/20 border border-white/20 text-white/90 text-xs px-3 py-1">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* 右侧匹配说明 */}
          <div>
            <h3 className="font-heading text-2xl md:text-3xl text-foreground-950">
              为什么是它？
            </h3>
            <p className="mt-3 text-foreground-700 text-sm md:text-base leading-relaxed">
              {pick.anime.year}年 · {pick.anime.episodes} · {pick.anime.studio}。缘分为你筛选出这一部与当下状态最合拍的作品，只管放心打开。
            </p>

            <ul className="mt-6 space-y-3">
              {pick.reasons.map((r, i) => (
                <li key={i} className="flex items-start gap-3 rounded-xl bg-background-100 border border-background-200/70 px-4 py-3">
                  <span className="mt-0.5 w-6 h-6 shrink-0 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                    {i + 1}
                  </span>
                  <p className="text-sm text-foreground-700 leading-relaxed">{r}</p>
                </li>
              ))}
            </ul>

            <button
              type="button"
              onClick={reMatch}
              className="mt-6 md:mt-7 inline-flex items-center gap-2 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-semibold px-7 py-3 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-refresh-line"></i>
              再配一次
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}